import React from "react";
import aboutImg from "../images/Aombre-round-logo.png";

const About = () => {
  const handleBookNowClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section className="bg-[#edebec] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-10">
        {/* --- Image Section --- */}
        <div className="w-full lg:w-1/2">
          <img
            src={aboutImg}
            alt="About Aombre"
            className="rounded-2xl object-cover w-full h-[250px] lg:h-[400px]"
          />
        </div>

        {/* --- Text Section --- */}
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h2 className="text-4xl font-bold text-[#006039] mb-4">
            ABOUT <span className="text-[#ca8032]">AOMBRE</span>
          </h2>
          <p className="text-gray-600 text-lg mb-6 leading-relaxed">
            AOMBRE is redefining car rentals with simplicity, reliability, and
            transparency. Whether it’s a business trip, family vacation, or
            spontaneous getaway, we provide modern, well-maintained vehicles
            that suit every need and budget.
          </p>
          <p className="text-gray-600 text-lg mb-6 leading-relaxed">
            With an expanding network across major cities, our mission is to
            make mobility accessible, convenient, and affordable for everyone.
            From booking to return, AOMBRE ensures a seamless rental experience
            backed by trusted customer support.
          </p>

          <button
            onClick={handleBookNowClick}
            className="bg-[#ca8032] text-white font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-[#b56d28] transition-all"
          >
            Book Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default About;
